import React, { useState } from 'react';
import { Trash2 } from 'lucide-react';
import { Button } from '../../../../components/ui/Button';

const inputClass =
  'w-full min-w-0 bg-ninja-gray/50 dark:bg-[#111] border border-border rounded-xl px-3 py-2 text-sm text-ninja-dark dark:text-white outline-none focus:border-ninja-green transition-colors';

// The same three columns for the "add" row and the stored rows, with a fixed
// width for the action: sized by their own button, "Agregar" and the trash icon
// pushed the key and value columns out of line.
const rowLayout = 'grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)_5.5rem] items-center gap-2';

const KeyValueEditor = ({
  title,
  testId,
  store,
  addCustomValue,
  updateKey,
  updateValue,
  removeKey,
  handleSnack,
}) => {
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");

  const handleAdd = (event) => {
    event.preventDefault();
    addCustomValue(newKey, newValue, handleSnack);
    setNewKey("");
    setNewValue("");
  };

  return (
    <div data-testid={testId} className="space-y-2">
      <h4 className="text-sm font-bold text-ninja-dark dark:text-white">{title}</h4>

      <div className={rowLayout}>
        <input
          aria-label="Agregar llave"
          placeholder="Agregar llave"
          value={newKey}
          onChange={(event) => setNewKey(event.target.value)}
          className={inputClass}
        />
        <input
          aria-label="Agregar valor"
          placeholder="Agregar valor"
          value={newValue}
          onChange={(event) => setNewValue(event.target.value)}
          className={inputClass}
        />
        <Button type="button" variant="primary" size="sm" fullWidth onClick={handleAdd}>
          Agregar
        </Button>
      </div>

      {store.map((item) => (
        <div key={item.id} data-testid={`${testId}-row`} className={rowLayout}>
          <input
            aria-label="Llave"
            value={item.key}
            onChange={(event) => updateKey(item.id, event.target.value)}
            className={inputClass}
          />
          <input
            aria-label="Valor"
            value={item.value}
            onChange={(event) => updateValue(item.id, event.target.value)}
            className={inputClass}
          />
          <Button
            type="button"
            variant="subtle"
            size="sm"
            icon={Trash2}
            iconOnly
            aria-label={`Eliminar ${item.key}`}
            className="justify-self-center"
            onClick={() => removeKey(item.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default KeyValueEditor;
